module.exports = "pegasus/assets/blocks/header-1-tech.png";